import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const AllStatusList =(params) => AxiosClient.get('/status', params);
export {
    AllStatusList,
}